import { ViewCard } from '../../../../component/common/ViewCard/view-card';
import { FaEdit } from 'react-icons/fa';
import { motion } from 'framer-motion';
import Icon from '../../../../components/common/Icon';

type CardItem = {
  id: string;
  title: string;
  description?: string;
  routePath: string;
  icon?: JSX.Element;
  backgroundColor?: string;
  textColor?: string;
  className?: string;
}

const cardData = (processId: number): CardItem[] => [
  {
    id: "question-resource",
    title: "Recurso de Questões",
    description: "Solicite recurso para questões de um simulado.",
    routePath: `/process/${processId}/resource/question`,
    icon: <Icon icon={FaEdit} size={36} />,
    backgroundColor: "#fff8e1",
    textColor: "#ff6f00",
    className: "bg-warning-soft",
  },
];

type ViewListCardProps = {
  processId: number;
};


export function ViewListCardResource({ processId }: ViewListCardProps) {
  const cards = cardData(processId);
  return (
    <div className="container py-4">
      <div className="row g-4">
        {cards.map((card: CardItem, index: number) => (
          <motion.div
            key={card.id}
            className="col-12 col-md-6 col-lg-4 col-xl-3 d-flex"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <ViewCard
              title={card.title}
              description={card.description}
              icon={card.icon}
              routePath={card.routePath}
              backgroundColor={card.backgroundColor}
              textColor={card.textColor}
              className={card.className}
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
}
